import skillset from '../assets/img/Skillset.png'
import skillset2 from '../assets/img/Skillset2.png'
import '../assets/css/SkillsetSection.css'
// import Slide from 'react-reveal/Slide';
import Roll from 'react-reveal/Roll';

function SkillsetSection() {
    return (
        <div className="sec3">
            <Roll right>
            <div className="skillsetSec">
                <h2>Skillset</h2>
                <img src={skillset} className="set1" alt="skillset" width="900"/>
                <img src={skillset2} className="set2" alt="skillset" width="600"/>
            </div>
            </Roll>
        </div>
        );
    }
    
export default SkillsetSection;